import { render, staticRenderFns } from "./edit_cnab_remittance.vue?vue&type=template&id=1f070ff8&scoped=true&"
import script from "./edit_cnab_remittance.vue?vue&type=script&lang=js&"
export * from "./edit_cnab_remittance.vue?vue&type=script&lang=js&"
import style0 from "./edit_cnab_remittance.vue?vue&type=style&index=0&id=1f070ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f070ff8",
  null
  
)

export default component.exports